import React from 'react';

import classes from './model-card.module.css';

const ModelCard = props => {
  let model = props.data;

  return (
    <div className={classes.ModelCard}>
      <div className={classes.ModelInfo}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: 16,
            fontWeight: 'bold'
          }}
        >
          <div style={{}}>
            {model.make} {model.model}
          </div>
          <div>{model.nett_price}</div>
        </div>
        <div className="text-color-deepblue60" style={{ fontSize: 14 }}>
          {model.submodel}
        </div>
        <div className={`${classes.PriceSubInfo} text-color-urbangrey60`}>
          <span>VES Category: {model.ves_category}</span>
          <span>Rebate: {model.ves_rebate}</span>
        </div>
      </div>
      <div className={classes.PriceInfo} />
    </div>
  );
};

export default ModelCard;
